import importer from "common/importer";
/* NAVIGATOR */
const { navigate, ROUTES } = importer("NavigationService", null);
const { edqAuth } = importer("APIs/users", null);
const { tokens } = importer("Stores/Users/Select", null);
const DonorsActions = importer("Stores/Donors/Actions");
const WirecardActions = importer("Stores/Wirecard/Actions");
import { select, put } from "redux-saga/effects";

const i18n = importer("i18n");

const Config = importer("Config");
export default function* success(data) {
  // alert('heroku login success saga')
  const origin = sessionStorage.getItem("authOrigin");
  const allowedOrigins = Config.EDQ_AUTH_URL && Config.EDQ_AUTH_URL.split(";");
  //change language according to user preferred
  if (data.res.language) {
    i18n.changeLanguage(data.res.language);
  } else {
    i18n.changeLanguage("en-US");
  }

  if (data?.res?.pdn) {
    yield put(DonorsActions.inquiryDonor(data?.res?.pdn));
    yield put(WirecardActions.getWirecardInfo(data?.res?.pdn));
  }
  if (allowedOrigins && allowedOrigins.includes(origin)) {
    const _tokens = yield select(tokens);
    const { token_type, id_token, access_token } = _tokens;
    const token = `${token_type} ${id_token} ${access_token}`;
    let newLocation = yield edqAuth(token);
    window.location.replace(newLocation.data.url);
  } else {
    /*redirecting to donor routes when the role is superAdmin 
    reason : superAdmin what to view the profile as a donor */
    const redirectTo = data.res.defaultCenter
      ? ROUTES.DonorDashboard
      : ROUTES.ChooseDonationCenter;

    const route =
      data.res.role === "Donor" || data.res.role === "SuperAdmin"
        ? redirectTo
        : ROUTES.CenterDashboard;
    /**
     * Additing timeout to avoid intermittent issue where heroku login is not persisted.
     * This may be due to fast refresh after authorize call where heroku login session is setup with the login data
     */
    yield setTimeout(() => {
      navigate(route);
    }, 2000);
  }
}
